import { ReactNode } from 'react';

type Listener = () => void;

class SlotFillManagerClass {
  private fills: Map<string, ReactNode[]> = new Map();
  private listeners: Map<string, Set<Listener>> = new Map();

  registerFill(slotId: string, content: ReactNode): void {
    if (!slotId) return;

    const currentFills = this.fills.get(slotId) || [];
    this.fills.set(slotId, [...currentFills, content]);
    this.notifyListeners(slotId);
  }

  unregisterFill(slotId: string, content: ReactNode): void {
    if (!slotId) return;

    const currentFills = this.fills.get(slotId) || [];
    const newFills = currentFills.filter(fill => fill !== content);

    if (newFills.length === 0) {
      this.fills.delete(slotId);
    } else {
      this.fills.set(slotId, newFills);
    }

    this.notifyListeners(slotId);
  }

  getFills(slotId: string): ReactNode[] {
    return this.fills.get(slotId) || [];
  }

  subscribe(slotId: string, listener: Listener): void {
    if (!this.listeners.has(slotId)) {
      this.listeners.set(slotId, new Set());
    }
    this.listeners.get(slotId)!.add(listener);
  }

  unsubscribe(slotId: string, listener: Listener): void {
    const listeners = this.listeners.get(slotId);
    if (listeners) {
      listeners.delete(listener);
      if (listeners.size === 0) {
        this.listeners.delete(slotId);
      }
    }
  }

  private notifyListeners(slotId: string): void {
    const listeners = this.listeners.get(slotId);
    if (listeners) {
      listeners.forEach(listener => listener());
    }
  }
}

export const SlotFillManager = new SlotFillManagerClass();
